import { selectData } from '../../../utils/select-data';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { Vehicle, vehicleSchema } from '../schemas/vehicle.schema';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Edits Vehicles
 * @param vehicles The Vehicles being edited
 * @returns Data object indicating success
 */
export function putVehicles(this: unknown, vehicles: Partial<Vehicle>[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).vehiclesUrl, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(vehicles),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(vehicleSchema),
        message: z.string().nullable(),
      })
    )
  );
}
